import { Component, ElementRef, OnDestroy, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { IonicPage, NavParams, ViewController } from "ionic-angular";
import { Action, DocumentUploadedAction } from "models/order-management/models";
import { OrderPatchRequest } from "models/order-management/orderPatchRequest";
import { OrderResponse } from "models/order-management/orderResponse";
import * as moment from "moment-timezone";
import { DocManagementDataService } from "providers/doc-management-data-service/doc-management-data-service";
import { NavBarServiceProvider } from "providers/nav-bar-service/nav-bar-service";
import { OrderManagementDataService } from "providers/order-management-data-service/order-management-data-service";
import { UtilityService } from "providers/utility-service/utility-service";
import Utils from "utils/Utilities";
import { StateManagementService } from "../../../providers/state-management/state-management.service";
import { BasePage } from "../../base-page";

@IonicPage()
@Component({
  selector: "upload-order-documents",
  templateUrl: "upload-order-documents.html",
})
export class UploadOrderDocumentsPopover extends BasePage implements OnDestroy {
  selected = 0;
  addNoteForm: FormGroup;
  ordersId = [];
  userDisplayName: string;
  notes: string;
  enableSave: boolean = true;
  signatureRequest: Action.SignatureRequestEnum;

  @ViewChild("inputFile") inputFile: ElementRef;
  listFiles = [];
  idFiles: string[] = [];
  numberOfFiles = 0;
  dataTransfer = new DataTransfer();
  showToaster = false;
  hideAllOrderManagment: boolean = false;
  orderPatientChartId = 0;
  order: OrderResponse;

  constructor(
    public stateDate: StateManagementService,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    private utilityService: UtilityService,
    private navBarService: NavBarServiceProvider,
    private dataService: DocManagementDataService,
    private orderManagementDataService: OrderManagementDataService
  ) {
    super(stateDate);
    this.addNoteForm = new FormGroup({
      note: new FormControl(""),
    });
    this.ordersId = this.navParams.data.addNoteOrders;
    this.userDisplayName = this.navParams.data.userDisplayName;

    this.hideAllOrderManagment = !!this.navParams.data.hideAllOrderManagment;
    this.orderPatientChartId = this.navParams.data.orderPatientChartId;
    this.order = this.navParams.data.order;
    this.signatureRequest = this.navParams.data.signatureRequest;
  }

  onDismiss() {
    this.viewCtrl.dismiss({ cancel: true, shouldReload: false });
  }

  selectFile(e) {
    const { files } = e.target;
    for (let i = 0; i < files.length; i++) {
      if (files[i].size < 10485760) {
        this.listFiles.push(files[i]);
        this.dataTransfer.items.add(e.target.files[i]);
      } else {
        this.showToaster = true;
      }
    }
    if (this.showToaster) {
      this.utilityService.presentCustomErrorToast(
        "Some files exceed the size limit."
      );
      this.showToaster = false;
    }
    e.target.files = this.dataTransfer.files;
    let filesCounter = this.listFiles.filter((f) => f !== undefined).length;
    if (filesCounter > 0) {
      this.enableSave = false;
    } else {
      this.enableSave = true;
    }
  }

  deleteFile(event: any, index: number) {
    this.dataTransfer.items.remove(index);
    const newFileList = [];
    this.inputFile.nativeElement.files = this.dataTransfer.files;
    for (let i = 0; i < this.listFiles.length; i++) {
      newFileList.push(this.dataTransfer.files[i]);
    }
    this.listFiles = newFileList;
    let filesCounter = this.listFiles.filter((f) => f !== undefined).length;
    if (filesCounter > 0) {
      this.enableSave = false;
    } else {
      this.enableSave = true;
    }
  }

  async uploadFile() {
    const internalListFiles = this.listFiles.filter((x) => x !== undefined);
    if (internalListFiles.length != 0) {
      await Promise.all(
        internalListFiles.map(async (file) => {
          let payload = {
            key: this.hideAllOrderManagment
              ? this.orderPatientChartId
              : this.navBarService.getExternalId(),
            label: Utils.getFileName(file.name),
            serviceName: "PatientChart",
            fileExtension: file.name.slice(file.name.lastIndexOf(".")),
            description: "Order File",
            category: "Provider Orders",
            patientID: this.hideAllOrderManagment
              ? this.orderPatientChartId
              : this.navBarService.getExternalId(),
          };
          let body = new FormData();
          body.append("file", file);
          body.append("tags", JSON.stringify(payload));

          this.dataService.uploadDocument(body).subscribe(
            (data) => {
              this.idFiles.push(data["documentId"].toString());
              if (this.idFiles.length == internalListFiles.length) {
                let orderPatch: DocumentUploadedAction = {
                  actionType: Action.ActionTypeEnum.DocumentUploaded,
                  displayName: this.userDisplayName,
                  timezone: moment.tz.guess(),
                  documentIds: this.idFiles,
                  signatureRequests: [this.signatureRequest],
                };
                if (
                  !orderPatch.signatureRequests.includes("created") &&
                  !orderPatch.signatureRequests.includes("discontinued")
                ) {
                  console.error(Error);
                }
                this.patchOrder(orderPatch);
              }
            },
            (err) => {
              console.error(err.error);
              this.viewCtrl.dismiss({});
            }
          );
        })
      );
    }
  }

  patchOrder(orderPatchRequest: Partial<OrderPatchRequest>): void {
    const updateFile$ = this.orderManagementDataService.updateOrder(
      this.order.orderId,
      orderPatchRequest
    );
    this.viewCtrl.dismiss({ updateFile$ });
  }
}



// WEBPACK FOOTER //
// ./src/pages/order-managment/upload-order-documents/upload-order-documents.ts